<template>
  <div class="container">
    <div v-if="showSlotInfo">
      <van-swipe
        class="swipe"
        autoplay="5000"
        :style="sizeStyle"
        :show-indicators="showSwipe"
        @change="onChange"
      >
        <van-swipe-item
          v-for="(item, idx) in slotInfo.sourceList "
          :key="idx"
          @click="onClick(item, idx)"
        >
          <img
            :src="item.imgUrl"
          />
          <div
            v-if="item.tag"
            class="ad-tip"
          >
            广告
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  data() {
    return {
      index: -1,
    };
  },
  computed: {
    showSwipe() {
      return this.slotInfo && this.slotInfo.sourceList && this.slotInfo.sourceList.length > 1;
    },
  },
  watch: {
    showSlotInfo(value) {
      if (value) this.onChange(0);
    },
  },
  methods: {
    onChange(index) {
      if (this.index < index) {
        const ext = this.showSwipe ? { order: index } : {};
        this.sendMV(this.slotInfo.sourceList[index], ext);
        this.index = index;
      }
    },
    onClick(item, index) {
      const ext = this.showSwipe ? { order: index } : {};
      this.sendMC(item, ext);
      window.location.href = this.formatLandingPage(item.linkData, {});
    },
  },
};
</script>

<style lang="scss" scoped>
.swipe {
  margin: 18px auto;
}
.van-swipe-item {
  position: relative;
}
.ad-tip {
  position: absolute;
  top: 1px;
  right: 1px;
  background-color: rgba(245,245,245,0.5);
  padding: 2px;
  color: white;
}
</style>
